// @ts-strict-ignore
import * as chronos from 'ngx-bootstrap/chronos';
import { StringUtils } from '@shared/util/string-utils';

export class DateFormatter {
  private static readonly dateFormat: string = 'DD.MM.YYYY - HH:mm';
  private static readonly shortDateFormat: string = 'DD.MM.YYYY';
  private static readonly timestampDateFormat: string = 'YYYYMMDDHHmmss';
  private static readonly optionDateFormat: string = 'YYYY-MM-DD'; // ISO local date (without timezone)

  public static formatDate(date: Date): string {
    return this.formatDateInternal(date, this.dateFormat);
  }

  public static formatShortDate(date: Date): string {
    return this.formatDateInternal(date, this.shortDateFormat);
  }

  public static formatTimestamp(date: Date): string {
    return this.formatDateInternal(date, this.timestampDateFormat);
  }

  public static formatOptionDate(date: Date): string {
    return this.formatDateInternal(date, this.optionDateFormat);
  }

  public static parseShortDate(date: string): Date {
    return this.parseDate(date, this.shortDateFormat);
  }

  private static formatDateInternal(date: Date, format: string): string {
    if (!date) {
      return '';
    }
    return chronos.formatDate(date, format);
  }

  private static parseDate(date: string, format: string): Date {
    if (StringUtils.isEmpty(date)) {
      return null;
    }
    return chronos.parseDate(date, format);
  }

  public static userTimeZoneGMT(): string {
    const timeZoneOffset: number = -(new Date().getTimezoneOffset());
    const sign: string = timeZoneOffset < 0 ? '-' : '+';

    const absOffset: number = Math.abs(timeZoneOffset);
    return 'GMT' + sign + this.pad(Math.trunc(absOffset / 60), 2) + this.pad(absOffset % 60, 2);
  }

  private static pad(value: number, size: number): string {
    let result: string = '' + value;
    while (result.length < size) {
      result = '0' + result;
    }
    return result;
  }
}
